import type { TransferStatus, TransferStoreRefDto } from '@matix/api-client';
import { useLang } from '../../lib/language';

export function storeName(s: TransferStoreRefDto | { name: string; name_ar: string | null }, lang: string): string {
  return (lang === 'ar' ? s.name_ar : s.name) || s.name || s.name_ar || '—';
}

export function StatusChip(props: { status: TransferStatus }): JSX.Element {
  const { t } = useLang();
  const label = {
    pending: t({ en: 'Pending', ar: 'قيد الانتظار' }),
    received: t({ en: 'Received', ar: 'تم الاستلام' }),
    cancelled: t({ en: 'Cancelled', ar: 'ملغي' }),
  }[props.status];
  return <span className={`tr-status tr-status--${props.status}`}>{label}</span>;
}

/**
 * Cancel request and "Transfer now" are done in the ERP, not at the till
 * (user's decision, 2026-09-27). The buttons are hidden here; the API routes
 * are left as they are, so flipping this back to true restores both.
 * Receive is NOT behind this flag: it shows whenever the server says
 * `can_receive`, which requires the POS "Receive Transfers" permission (066).
 */
export const TILL_CANCELS_AND_TRANSFERS_NOW = false;
